<template>
    <div id="hqSettingBox">        
        <div class="searchWrap">
            <div class="row1" v-if="divVisible">
                <div class="itemWrap" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                    <div style="display: flex; align-items: center;">
                        <DivSelection :key="divSelectionRenderKey" v-model="selectedDiv" :filterDivisionCode="filterDivisionCode" @branch-selected="handleDivChange" style="margin-right: 1rem;"  />
                        <el-input v-model="keyword" placeholder="單位名稱" style="width:300px;" clearable></el-input>                    
                        <el-button style="margin-left: 1rem;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                    </div>          
                    <div>
                        <el-button type="danger" v-if="btnOptions.addBtn" icon="el-icon-plus" @click="addBranch">新增分行</el-button>
                    </div>
                </div>
            </div>          
        </div>

        <div class="content" style="margin-top:20px;">
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">              
              <el-table-column label="區處"  prop="DivisionName" min-width="5%">
              </el-table-column>                              
              <el-table-column label="分支機構代號" prop="BranchCode"  min-width="15%">                
              </el-table-column>              
              <el-table-column label="機構名稱"  prop="BranchFullName" min-width="20%">                
              </el-table-column>  
                <el-table-column label="代號" prop="DeptID" min-width="10%">
                </el-table-column>
                <el-table-column label="單位名稱" prop="DeptName" min-width="10%">
                </el-table-column>
              <el-table-column label="負責人"  prop="Manager" min-width="10%"  >
              </el-table-column>                        
              <el-table-column label="地址" prop="Address" min-width="20%">  
              </el-table-column>
              <el-table-column label="企業資訊" min-width="10%">
                <template slot-scope="scope">                    
                    <el-button type="text" v-if="btnOptions.editBtn" @click="editBranch(scope.row)" icon="el-icon-edit">編輯</el-button>
                    <el-button type="text" v-if="! btnOptions.editBtn && btnOptions.queryBtn" @click="editBranch(scope.row)" icon="el-icon-edit">明細</el-button>
                    <el-button type="text" v-if="btnOptions.delBtn" @click="delBranch(scope.row)" icon="el-icon-delete">刪除</el-button>   
                    <el-button type="text" v-if="btnOptions.settingBtn" @click="settingBranchPreference(scope.row)" icon="el-icon-setting">偏好</el-button>
                </template>
              </el-table-column>                                 
            </el-table>                
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists">
            </Pagination>
        </div>          
        <!-- <div class="buttonBox">            
            <el-button type="danger"  @click="closeWin()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </div>    -->
        <el-dialog :title="dialogTitle" :visible.sync="showAddBranch" width="60%" center>
            <div class="dialogBox" >
                <el-form :model="addInfo" :rules="addInfoRules" ref="addInfoForm" label-width="150px">
                    <div class="row1">
                        <div class="itemBox" >
                            <el-form-item label="分支機構代碼：" prop="BranchCode" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.BranchCode" placeholder="請輸入分支機構代碼" ></el-input>
                            </el-form-item>                                                        
                            <el-form-item label="分支機構代碼：" v-else>
                                {{ addInfo.BranchCode }}
                            </el-form-item>
                            
                        </div>          
                        <div class="itemBox">
                            <el-form-item label="機構名稱：" prop="BranchFullName" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.BranchFullName" placeholder="請輸入機構名稱" ></el-input>
                            </el-form-item>
                            <el-form-item label="機構名稱：" v-else>
                                {{ addInfo.BranchFullName }}
                            </el-form-item>
                        </div>     
                    </div>                
                    <div class="row1">
                        <div class="itemBox">
                            <el-form-item label="代號：" prop="DeptID" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.DeptID" placeholder="請輸入代號" ></el-input>
                            </el-form-item>
                            <el-form-item label="代號：" v-else>
                                {{ addInfo.DeptID }}
                            </el-form-item>
                        </div>          
                        <div class="itemBox">
                            <el-form-item label="單位名稱：" prop="DeptName" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.DeptName" placeholder="請輸入單位名稱" ></el-input>
                            </el-form-item>
                            <el-form-item label="單位名稱：" v-else>
                                {{ addInfo.DeptName }}
                            </el-form-item>
                        </div>     
                    </div>
                    <div class="row1">
                        <div class="itemBox">
                            <el-form-item label="區處：" prop="DivisionName" v-if="btnOptions.editBtn">
                                <el-select v-model="addInfo.DivisionName" placeholder="選擇區處" style="width: 100%;">
                                    <el-option
                                        v-for="item in divisionList"
                                        :key="item.DivisionCode"
                                        :label="item.DivisionName"
                                        :value="item.DivisionCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="區處：" v-else>
                                {{ addInfo.DivisionName }}
                            </el-form-item>
                        </div>
                        <div class="itemBox">
                            <el-form-item label="負責人：" prop="Manager" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.Manager" placeholder="請輸入負責人" ></el-input>
                            </el-form-item>
                            <el-form-item label="負責人：" v-else>
                                {{ addInfo.Manager }}
                            </el-form-item>
                        </div>          
                    </div>                
                    <div class="row1">
                        <div class="itemBox">
                            <el-form-item label="分行經度：" prop="Longitude" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.Longitude" placeholder="請輸入分行經度" ></el-input>
                            </el-form-item>
                            <el-form-item label="分行經度：" v-else>
                                {{ addInfo.Longitude }}
                            </el-form-item>
                        </div>          
                        <div class="itemBox">
                            <el-form-item label="分行緯度：" prop="Latitude" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.Latitude" placeholder="請輸入分行緯度" ></el-input>
                            </el-form-item>
                            <el-form-item label="分行緯度：" v-else>
                                {{ addInfo.Latitude }}
                            </el-form-item>
                        </div>     
                    </div>
                    <div class="row1">
                        <div class="itemBox">
                            <el-form-item label="電話：" prop="Phone" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.Phone" placeholder="請輸入電話" ></el-input>
                            </el-form-item>
                            <el-form-item label="電話：" v-else>
                                {{ addInfo.Phone }}
                            </el-form-item>
                        </div>
                        <div class="itemBox">
                            <!-- 預留空間 -->
                        </div>
                    </div>
                    <div class="row1">
                        <div class="itemBox" style="width: 100%;">
                            <el-form-item label="地址：" prop="Address" v-if="btnOptions.editBtn">
                                <el-input v-model="addInfo.Address" placeholder="請輸入所在地" ></el-input>
                            </el-form-item>
                            <el-form-item label="地址：" v-else>
                                {{ addInfo.Address }}
                            </el-form-item>
                        </div>                         
                    </div>
                </el-form>
                    
               
            </div>
            <span slot="footer" class="dialog-footer">
                    <!-- <el-button type="success"  @click="branchPreferenceDrawerVisible = true" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />設定分行偏好</el-button> -->
                    <el-button type="primary" v-if="btnOptions.editBtn" @click="submitAddInfo" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />{{ dialogButton}}</el-button>
                    <el-button type="danger"  @click="showAddBranch=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>     
        
        
        <el-dialog title="設定分行偏好" :visible.sync="showBranchPreference" width="75%" center>
            <div class="dialogBox" >

                <div class="row2">
                    <div class="itemBox">
                        <label style="margin-right: 1rem;">已選擇條件</label>
                        <el-tag v-for="tag in lstQuery" :key="tag"  type="success" closable :disable-transitions="false" style="margin-right: 5px;" @close="handleClose(tag)">
                        {{tag}}
                        </el-tag>                        
                    </div>
                    <!-- <el-input v-model="addInfo.ssWord" placeholder="請輸入分行代碼" ></el-input>       -->
                </div>
                
                <div class="row2">
                    <div class="titleLabel">所在縣市</div>
                    <DistSelection v-model="selectedAreaValue" width="200px" @area-change="handleDistrictChange" />
                </div>

                <div class="row2">                    
                    <div class="titleLabel">篩選條件</div>                                    
                    <div class="itemWrap">                                                        
                        <el-dropdown placement="bottom-start" @command="comStatusChangeHandler" trigger="click">
                            <span class="el-dropdown-link">
                                公司狀況<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="全部">全部</el-dropdown-item>
                                <el-dropdown-item command="營業中">營業中</el-dropdown-item>
                                <el-dropdown-item command="非營業中">非營業中</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="itemWrap">                    
                        <el-dropdown placement="bottom-start" @command="comTypeChangeHandler" trigger="click">
                            <span class="el-dropdown-link">
                                公司類別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="全部">全部</el-dropdown-item>
                                <el-dropdown-item v-for="item in ComTypeList" :key="item.comType" :command="item.comType">
                                    {{ item.comType }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>                    
                    <div class="itemWrap">                    
                        <el-dropdown placement="bottom-start" @command="orgTypeChangeHandler" trigger="click">
                            <span class="el-dropdown-link">
                                組織別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="全部">全部</el-dropdown-item>
                                <el-dropdown-item v-for="item in OrgTypeList" :key="item.comType" :command="item.comType">
                                    {{ item.comType }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>            
                    <div class="itemWrap">
                        <el-checkbox v-model="IsCustomer"  @change="otherChangeHandler('既有客戶')">
                            <label style="font-size: 13px;">既有客戶</label>
                        </el-checkbox>         
                    </div>         
                    <div class="itemWrap">
                        <el-checkbox v-model="IsInvoice"  @change="otherChangeHandler('有發票')">
                            <label style="font-size: 13px;">有發票</label>
                        </el-checkbox>         
                    </div>                          
                    <div class="itemWrap">
                        <el-checkbox v-model="IsImport"  @change="otherChangeHandler('有進口')">
                            <label style="font-size: 13px;">有進口</label>
                        </el-checkbox>         
                    </div>         
                    <div class="itemWrap">
                        <el-checkbox v-model="IsExport"  @change="otherChangeHandler('有出口')">
                            <label style="font-size: 13px;">有出口</label>
                        </el-checkbox>                  
                    </div>
                    <div class="itemWrap">
                        <el-checkbox v-model="IsFactory"  @change="otherChangeHandler('有工廠')">
                            <label style="font-size: 13px;">有工廠</label>
                        </el-checkbox>           
                    </div>
                </div>  
                <div class="row2">
                    <div class="titleLabel">進階條件</div>
                    <!-- 資本額 -->
                    <div class="itemWrap">
                        <el-dropdown placement="bottom-start" @command="radClick" trigger="click"> 
                            <span class="el-dropdown-link">
                                實收資本<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-money" v-for="c in capList" :command="c.value" :key="c.value" >
                                {{c.cap}}
                                </el-dropdown-item>
                                <el-dropdown-item icon="el-icon-edit" command="custom">
                                自訂區間
                                </el-dropdown-item>                                                
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    

                    <!-- 公司設立日期 -->
                    <div class="itemWrap">
                        <el-dropdown placement="bottom-start" @command="yearClick" trigger="click"> 
                        <span class="el-dropdown-link">
                            設立年數<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-date" v-for="c in yearList" :command="c.value" :key="c.value" >
                            {{c.cap}}
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-edit" command="custom">
                            自訂區間
                            </el-dropdown-item>                                                
                        </el-dropdown-menu>
                        </el-dropdown>
                    </div> 

                    <!-- 行業代號下拉選單 -->                
                    <div class="itemWrap">
                        <IndusCodeSelection size="small"
                            v-model="selectedIndustryCode"
                            @change="handleIndustryCodeChange"
                        /> 

                    </div>
                </div>                
                
                <!-- 加入潛在客戶的原因 -->
                <!-- <div style="margin: 5px 5px;">
                    <label>備註：</label>
                    <el-input type="textarea" rows="2" v-model="addInfo.memo"  placeholder="簡明描述備註" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                    
                </div>                 -->
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savePreference" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />儲存</el-button>
                    <el-button type="danger"  @click="showBranchPreference=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>

        <!-- 自訂資本額區間對話框 -->
        <el-dialog title="自訂資本額區間" :visible.sync="showCustomCapital" width="40%" center>
            <div class="dialogBox">
                <el-form label-width="100px">
                    <el-form-item label="起始金額">
                        <el-input v-model="customCapital.start" placeholder="請輸入起始金額（萬元）" type="number">
                            <template slot="append">萬元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="結束金額">
                        <el-input v-model="customCapital.end" placeholder="請輸入結束金額（萬元）" type="number">
                            <template slot="append">萬元</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmCustomCapital"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
                <el-button type="danger" @click="showCustomCapital=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
            </span>
        </el-dialog>

        <!-- 自訂設立日期區間對話框 -->
        <el-dialog title="自訂設立日期區間" :visible.sync="showCustomYear" width="40%" center>
            <div class="dialogBox">
                <el-form label-width="100px">
                    <el-form-item label="起始年限">
                        <el-input v-model="customYear.start" placeholder="請輸入起始年限（年）" type="number">
                            <template slot="append">年</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="結束年限">
                        <el-input v-model="customYear.end" placeholder="請輸入結束年限（年）" type="number">
                            <template slot="append">年</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmCustomYear"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
                <el-button type="danger" @click="showCustomYear=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
            </span>
        </el-dialog>         




    </div>

    
</template>

<script>
// import Pagination from '../../components/Pagination.vue';
// 已全域註冊 Breadcrumb，移除 import
import Breadcrumb from '@/components/Breadcrumb.vue';
import DivSelection from '../../components/DivSelection.vue';
import DistSelection from '@/components/DistSelection.vue';
import IndusCodeSelection from '@/components/IndusCodeSelection.vue'
import { notify, handleError } from '../../utils/notify';

export default {
    components: {DivSelection, DistSelection, IndusCodeSelection},
    data() {
        const validateLongitude = (rule, value, callback) => {
            if (value === null || value === undefined || value === '') {
                callback();
                return;
            }

            const valueStr = String(value).trim();
            const longitudePattern = /^-?\d{1,3}(\.\d{1,8})?$/;
            const digitsOnly = valueStr.replace('-', '').replace('.', '');

            if (!longitudePattern.test(valueStr) || digitsOnly.length > 11) {
                callback(new Error('經度格式需為 decimal(11,8)'));
                return;
            }

            callback();
        };

        const validateLatitude = (rule, value, callback) => {
            if (value === null || value === undefined || value === '') {
                callback();
                return;
            }

            const valueStr = String(value).trim();
            const latitudePattern = /^-?\d{1,2}(\.\d{1,8})?$/;
            const digitsOnly = valueStr.replace('-', '').replace('.', '');

            if (!latitudePattern.test(valueStr) || digitsOnly.length > 10) {
                callback(new Error('緯度格式需為 decimal(10,8)'));
                return;
            }

            callback();
        };

        return {
            divVisible: false,
            btnOptions: {
                addBtn: false,
                editBtn: false,
                delBtn: false,
                settingBtn: false,
                queryBtn: true
            },
            selectedRow: {},
            showBranchPreference: false,

            filterDivisionCode:'',

            // 表單驗證規則
            addInfoRules: {
                BranchCode: [
                    { required: true, message: '請輸入分行代碼', trigger: 'blur' },
                    { min: 2, max: 20, message: '長度在 2 到 20 個字符', trigger: 'blur' }
                ],
                BranchFullName: [
                    { required: true, message: '請輸入分行名稱', trigger: 'blur' },
                    { min: 2, max: 50, message: '長度在 2 到 50 個字符', trigger: 'blur' }
                ],
                DeptID: [
                    { required: true, message: '請輸入部門代碼', trigger: 'blur' }
                ],
                DeptName: [
                    { required: true, message: '請輸入部門名稱', trigger: 'blur' }
                ],
                DivisionName: [
                    { required: true, message: '請選擇所屬區處', trigger: 'change' }
                ],
                Manager: [
                    { required: true, message: '請輸入分行主管', trigger: 'blur' }
                ],
                Longitude: [
                    { validator: validateLongitude, trigger: 'blur' }
                ],
                Latitude: [
                    { validator: validateLatitude, trigger: 'blur' }
                ],
                Phone: [
                    { required: true, message: '請輸入電話號碼', trigger: 'blur' }
                ],
                Address: [
                    { required: true, message: '請輸入分行地址', trigger: 'blur' },
                    { min: 5, max: 200, message: '長度在 5 到 200 個字符', trigger: 'blur' }
                ]
            },

            divisionList: [
                { DivisionCode: "H91", DivisionName: "北一區" },
                { DivisionCode: "H92", DivisionName: "北二區" },
                { DivisionCode: "H93", DivisionName: "北三區" },
                { DivisionCode: "H94", DivisionName: "中區" },
                { DivisionCode: "H95", DivisionName: "南一區" },
                { DivisionCode: "H96", DivisionName: "南二區" }
            ],

            lstQuery: [],
            // 新增：結構化的查詢條件（用於 API 查詢）
            queryConditions: {
                keyword: '',           // 關鍵字
                companyStatus: '',     // 公司狀況
                companyType: [],       // 公司類別
                orgType: [],          // 組織別
                isCustomer: false,    // 既有客戶
                isInvoice: false,     // 有發票
                isImport: false,      // 有進口
                isExport: false,      // 有出口
                isFactory: false,     // 有工廠
                capital: {            // 資本額
                    start: '',
                    end: '',
                    range: ''         // 如 "0~100萬"
                },
                setupDate: {          // 設立日期
                    range: '',        // 如 "1-3年"
                    start: '',        // 計算後的開始日期，如 "2020-01-01"
                    end: '',          // 計算後的結束日期，如 "2022-12-31"
                    rangeValue: ''    // yearList 的 value
                },
                industryCode: [],     // 行業代碼
                location: {           // 地址
                    area: '',         // 區域：北部/中部/南部/東部
                    city: '',         // 縣市
                    district: ''      // 區域
                },
                geolocation: {        // 地理位置
                    Latitude: '',     // 緯度
                    Longitude: '',    // 經度
                    Distance: ''      // 距離，單位公里
                }                
            },    
            // 新增：查詢條件映射表（用於標籤與結構的對應）
            queryConditionMap: new Map(),        
            selectedComStatus: "",    
            selectedComType: "",
            // 其他篩選條件
            IsImport: false,
            IsExport: false,
            IsInvoice: false,
            IsCustomer: false,
            IsFactory: false,   
            
            selectedIndustryCode: [], // 單選：['A', '01', '011', '0111']   

            selectedDiv: [],
            divSelectionRenderKey: 0,
            selComType: "",


            selCity: '臺北市',
            selectedAreaValue: [],
            areaList: [
                {area: "北部", cities: ["臺北市", "新北市", "桃園市", "新竹市", "新竹縣", "宜蘭縣", "基隆市"]},
                {area: "中部", cities: ["臺中市", "彰化縣","苗栗縣", "南投縣", "雲林縣"]},
                {area: "南部", cities: ["高雄市", "臺南市", "嘉義市", "嘉義縣", "屏東縣"]},
                {area: "東部", cities: ["花蓮縣", "臺東縣","澎湖縣","金門縣","連江縣"]}
            ],              

            tableData: [],
            capList: [
                { cap: "2000萬(含)以下", value: 1, start: 0, end: 2000 },
                { cap: "2001萬~3000萬(含)以下", value: 2, start: 2001, end: 3000 },
                { cap: "3001萬~8000萬(含)以下", value: 3, start: 3001, end: 8000 },
                { cap: "8001萬~1億(含)以下", value: 4, start: 8001, end: 10000 },
                { cap: "1億(不含)以上", value: 5, start: 10001, end: 999999999 }        
            ],          
            yearList: [
                { cap: "未滿1年", start: 0, end: 1, value: 1 },
                { cap: "1年以上-未滿3年", start: 1, end: 3, value: 2 },
                { cap: "3年以上-未滿5年", start: 3, end: 5, value: 3 },
                { cap: "5年以上-未滿10年", start: 5, end: 10, value: 4 },
                { cap: "10年(含)以上", start: 10, end: 20, value: 5 }          
            ],               
            OrgTypeList: [
                { comType: "股份有限公司" },
                { comType: "有限公司" },
                { comType: "獨資" },
                { comType: "合夥" },
                { comType: "其他" }
            ],   

            ComTypeList: [
                { comType: "上市" },
                { comType: "上櫃" },
                { comType: "興櫃" },
                { comType: "公開發行" }
            ], 

            dialogTitle: '新增分行',
            dialogButton: '新增',

            
            showAddBranch: false,

            totalLists:0,
            keyword: "",  

            listQuery: {                
                Page_Size:10,
                Page_Num:1
            },   
            addInfo: {
            },
            roleName: '',
            deptID: '',
            DivisionCode: '',
            
            // 自訂資本額區間
            showCustomCapital: false,
            customCapital: {
                start: '',
                end: ''
            },
            
            // 自訂設立日期區間
            showCustomYear: false,
            customYear: {
                start: '',
                end: ''
            }
        }        

        
    },
    methods: {

        // 決定那些按鈕需要打開
        async getFunctions() {
            // 從 localStorage 獲取使用者功能列表
            const funs = this.$store.getters.userInfo;
            this.roleName = funs.Role[0];
            this.deptID = funs.DeptID;
            this.DivisionCode = funs.DivisionCode;
            // console.log("使用者角色", this.roleName);
            console.log("使用者功能列表", funs);
            if(funs && funs.Menu){
                const actions = funs.Menu.find(item=>item.Name=="分行帳號管理").Action || [];
                // console.log("使用者功能列表", actions);
                this.btnOptions.editBtn = actions.some(item => item.Action === "修改分行帳號");
                this.btnOptions.delBtn = actions.some(item => item.Action === "刪除分行帳號");
                this.btnOptions.settingBtn = actions.some(item => item.Action === "修改分行帳號");
                this.btnOptions.addBtn = actions.some(item => item.Action === "新增分行帳號");
                this.btnOptions.queryBtn = actions.some(item => item.Action === "查詢分行帳號");
                // console.log("是否有指派功能", this.assignBtnVisible);
            }
            // 決定DivSelect元件顯示的層級
            if( this.roleName=="HE" || this.roleName=="HC1" ){
                const branchArea = funs.DivisionCode;
                console.log('branchArea:', branchArea);
                this.filterDivisionCode = branchArea;
            }

            if( this.roleName === "UC"){
                this.divVisible = false;
            }
            else {
                this.divVisible = true;
            }
        },

        // 提交表單（驗證後執行新增或編輯）
        submitAddInfo() {
            this.$refs.addInfoForm.validate((valid) => {
                if (valid) {
                    // 驗證通過，執行新增或編輯
                    if (this.dialogButton === '新增') {
                        this.addBranchData();
                    } else if (this.dialogButton === '儲存') {
                        this.editBranchData();
                    }
                } else {
                    notify({
                        type: 'warning',
                        title: '提示',
                        message: '請填寫必填欄位'
                    });
                    return false;
                }
            });
        },
        
        // 新增分行資料
        addBranchData() {
            console.log('新增分行:', this.addInfo);
            // 從 DivisionList 取
            // 得 DivisionCode 和 DivisionName
            console.log('test', this.addInfo.DivisionName);
            const selectedDivision = this.divisionList.find(div => div.DivisionCode === this.addInfo.DivisionName);
            console.log('選擇的區處:', selectedDivision);
            const qry = {
                "DivisionCode": selectedDivision ? selectedDivision.DivisionCode : this.addInfo.DivisionCode,
                "DivisionName": selectedDivision ? selectedDivision.DivisionName : '',
                "DeptID": this.addInfo.DeptID,
                "DeptName": this.addInfo.DeptName,
                "BranchCode": this.addInfo.BranchCode,
                "BranchFullName": this.addInfo.BranchFullName,
                "Address": this.addInfo.Address,
                "Phone": this.addInfo.Phone,
                "Manager": this.addInfo.Manager,                
                "Latitude": this.addInfo.Latitude? this.addInfo.Latitude:0,
                "Longitude": this.addInfo.Longitude? this.addInfo.Longitude:0
            };

            // 如果經緯度為 0，則不帶入 API
            if( qry.Latitude === 0 || qry.Longitude === 0){
                delete qry.Latitude;
                delete qry.Longitude;
            }

            //console.log('發送的新增分行資料:', qry);
            // TODO: 調用 API 新增分行
            this.$api.apidivison.division_info_create(qry).then(res => {
                
                if( res && res.success == false) {
                 
                    if( res.statuscode == "E101" ) {
                        notify({ type: 'error', title: '錯誤', message: '分行代碼已存在，請使用其他代碼' });
                    }
                    else {
                        notify({ type: 'error', title: '錯誤', message: '分行新增失敗' });
                    }
                    return;
                }
                
                //console.log('新增分行成功:', res);
                notify({ type: 'success', title: '成功', message: '分行新增成功' });
                this.showAddBranch = false;
                this.refreshDivSelection();
                this.getList();
                
            }).catch(err => {
                notify({ type: 'error', title: '錯誤', message: '分行新增失敗' });
            });
        },
        
        // 編輯分行資料
        editBranchData() {
            console.log('編輯分行:', this.addInfo);
            if (!this.addInfo || !this.addInfo.ID) {
                notify({ type: 'error', title: '錯誤', message: '缺少 ID，無法更新分行資料' });
                return;
            }

            const qry = {
                ...this.addInfo,
                ID: this.addInfo.ID
            };
            // TODO: 調用 API 編輯分行
            this.$api.apidivison.division_info_update(qry).then(res => {
                notify({ type: 'success', title: '成功', message: '分行編輯成功' });
                this.showAddBranch = false;
                this.refreshDivSelection();
                console.log('編輯分行成功:', res);
                this.getList();
            }).catch(err => {
                notify({ type: 'error', title: '錯誤', message: '分行編輯失敗' });
            });
        },        

        refreshDivSelection() {
            // 重建元件前先清掉舊選擇，避免沿用舊 DeptID/DivisionCode
            this.selectedDiv = [];
            delete this.listQuery.DeptID;
            delete this.listQuery.DivisionCode;
            this.divSelectionRenderKey += 1;
        },

        async AreaSelect(item) {
            this.selCity = item;
            this.selectedCity = item;                        
            this.addQueryCondition('location', item, item); 
        },

        handleDistrictChange(values) {
            // values是DistSelection發出的區域路徑陣列
            // 如果是空陣列（選了全部），移除之前的location條件
            if (!values || values.length === 0) {
                // 移除之前帶有location的標籤
                for (let tag of this.lstQuery) {
                    const mapping = this.queryConditionMap.get(tag);
                    if (mapping && mapping.type === 'location') {
                        this.removeQueryCondition(tag);
                        break;
                    }
                }
                return;
            }
            
            // 根據選擇層級決定顯示內容
            if (values.length === 2) {
                // [區域名稱, 縣市名稱]
                const displayText = values[1];
                const locationValue = { 
                    area: values[0], 
                    city: values[1], 
                    district: '' 
                };
                this.addQueryCondition('location', locationValue, displayText);
            } else if (values.length === 3) {
                // [區域名稱, 縣市名稱, 區名稱]
                const displayText = `${values[1]}-${values[2]}`;
                const locationValue = { 
                    area: values[0], 
                    city: values[1], 
                    district: values[2] 
                };
                this.addQueryCondition('location', locationValue, displayText);
            }
        },        

        // 儲存分行偏好設定
        savePreference() {
            // 模擬儲存動作
            console.log('selectedRow:', this.selectedRow);
            console.log('偏好設定已儲存:', this.queryConditions);
            if (!this.selectedRow || !this.selectedRow.ID) {
                notify({
                    type: 'error',
                    title: '錯誤',
                    message: '缺少 ID，無法更新分行偏好設定'
                });
                return;
            }

            const qry = {
                "ID": this.selectedRow.ID,
                "Parameters": this.queryConditions
            }

            console.log('發送的查詢參數:', qry);

            this.$api.apidivison.division_info_update(qry).then((res)=>{
                console.log('API 回應:', res);
                notify({
                    type: 'success',
                    title: '成功',
                    message: '分行偏好設定已更新！'
                });
                setTimeout(() => {
                    this.getList();                    
                }, 1000);
            }).catch((error)=>{
                console.error('API 錯誤:', error);
                notify({
                    type: 'error',
                    title: '錯誤',
                    message: '無法更新分行偏好設定，請稍後再試。'
                });
            });
            this.showBranchPreference = false;
            
        },

        // 新增查詢條件（同時更新 lstQuery 和 queryConditions）
        addQueryCondition(type, value, displayText) {
            // 1. 更新顯示標籤
            if (!this.lstQuery.includes(displayText)) {
                this.lstQuery.push(displayText);
            }
            
            // 2. 更新結構化資料
            switch(type) {
                case 'keyword':
                    this.queryConditions.keyword = value;
                    break;
                    
                case 'companyStatus':
                    this.queryConditions.companyStatus = value;
                    break;
                    
                case 'companyType':
                    if (!this.queryConditions.companyType.includes(value)) {
                        this.queryConditions.companyType.push(value);
                    }
                    break;
                    
                case 'orgType':
                    if (!this.queryConditions.orgType.includes(value)) {
                        this.queryConditions.orgType.push(value);
                    }
                    break;
                    
                case 'isCustomer':
                    this.queryConditions.isCustomer = value;
                    break;
                    
                case 'isInvoice':
                    this.queryConditions.isInvoice = value;
                    break;
                    
                case 'isImport':
                    this.queryConditions.isImport = value;
                    break;
                    
                case 'isExport':
                    this.queryConditions.isExport = value;
                    break;
                    
                case 'isFactory':
                    this.queryConditions.isFactory = value;
                    break;
                    
                case 'capital':
                    this.queryConditions.capital = value;
                    break;
                    
                case 'setupDate':
                    this.queryConditions.setupDate = value;
                    break;
                    
                case 'industryCode':
                    if (!this.queryConditions.industryCode.includes(value)) {
                        this.queryConditions.industryCode.push(value);
                    }
                    break;
                    
                case 'location':
                    // 支持傳入完整的location object或只傳city字串
                    if (typeof value === 'object' && value.area !== undefined) {
                        this.queryConditions.location = value;
                    } else {
                        this.queryConditions.location = { area: '', city: value, district: '' };
                    }
                    break;
            }
            
            // 3. 建立映射關係（標籤文字 -> 條件類型和值）
            this.queryConditionMap.set(displayText, { type, value });
            
            console.log('查詢條件已更新:', {
                displayTags: this.lstQuery,
                structuredData: this.queryConditions,
                mapping: Array.from(this.queryConditionMap.entries())
            });
        },
        
        // 移除查詢條件
        removeQueryCondition(displayText) {
            // 1. 從顯示標籤中移除
            const index = this.lstQuery.indexOf(displayText);
            if (index > -1) {
                this.lstQuery.splice(index, 1);
            }
            
            // 2. 從結構化資料中移除
            const mapping = this.queryConditionMap.get(displayText);
            if (mapping) {
                const { type, value } = mapping;
                
                switch(type) {
                    case 'keyword':
                        this.queryConditions.keyword = '';
                        this.keyword = '';
                        break;
                        
                    case 'companyStatus':
                        this.queryConditions.companyStatus = '';
                        this.selectedComStatus = '全部';
                        break;
                        
                    case 'companyType':
                        const ctIndex = this.queryConditions.companyType.indexOf(value);
                        if (ctIndex > -1) {
                            this.queryConditions.companyType.splice(ctIndex, 1);
                        }
                        break;
                        
                    case 'orgType':
                        const otIndex = this.queryConditions.orgType.indexOf(value);
                        if (otIndex > -1) {
                            this.queryConditions.orgType.splice(otIndex, 1);
                        }
                        break;
                        
                    case 'isCustomer':
                        this.queryConditions.isCustomer = false;
                        this.IsCustomer = false;
                        break;
                        
                    case 'isInvoice':
                        this.queryConditions.isInvoice = false;
                        this.IsInvoice = false;
                        break;
                        
                    case 'isImport':
                        this.queryConditions.isImport = false;
                        this.IsImport = false;
                        break;
                        
                    case 'isExport':
                        this.queryConditions.isExport = false;
                        this.IsExport = false;
                        break;
                        
                    case 'isFactory':
                        this.queryConditions.isFactory = false;
                        this.IsFactory = false;
                        break;
                        
                    case 'capital':
                        this.queryConditions.capital = { start: '', end: '', range: '' };
                        this.TotCapStart = '';
                        this.TotCapEnd = '';
                        this.radCap = '';
                        break;
                        
                    case 'setupDate':
                        this.queryConditions.setupDate = { range: '', start: '', end: '', rangeValue: '' };
                        this.yearCap = '';
                        break;
                        
                    case 'industryCode':
                        const icIndex = this.queryConditions.industryCode.indexOf(value);
                        if (icIndex > -1) {
                            this.queryConditions.industryCode.splice(icIndex, 1);
                        }
                        break;
                        
                    case 'location':
                        this.queryConditions.location = { area: '', city: '', district: '' };
                        this.selectedCity = '全部';
                        this.selectedDistrict = '';
                        break;
                }
                
                // 3. 從映射表中移除
                this.queryConditionMap.delete(displayText);
            }
        },
        
        // 從 queryConditions 重建 lstQuery 和映射關係（用於編輯模式）
        rebuildFromQueryConditions(conditions) {
            // 清空現有狀態
            this.lstQuery = [];
            this.queryConditionMap.clear();
            
            if (!conditions) return;
            
            // 關鍵字
            if (conditions.keyword) {
                this.lstQuery.push(conditions.keyword);
                this.queryConditionMap.set(conditions.keyword, { type: 'keyword', value: conditions.keyword });
                this.keyword = conditions.keyword;
            }
            
            // 公司狀況
            if (conditions.companyStatus) {
                this.lstQuery.push(conditions.companyStatus);
                this.queryConditionMap.set(conditions.companyStatus, { type: 'companyStatus', value: conditions.companyStatus });
            }
            
            // 公司類別（陣列）
            if (conditions.companyType && Array.isArray(conditions.companyType)) {
                conditions.companyType.forEach(type => {
                    this.lstQuery.push(type);
                    this.queryConditionMap.set(type, { type: 'companyType', value: type });
                });
            }
            
            // 組織別（陣列）
            if (conditions.orgType && Array.isArray(conditions.orgType)) {
                conditions.orgType.forEach(type => {
                    this.lstQuery.push(type);
                    this.queryConditionMap.set(type, { type: 'orgType', value: type });
                });
            }
            
            // 布林值條件
            if (conditions.isCustomer) {
                this.lstQuery.push('既有客戶');
                this.queryConditionMap.set('既有客戶', { type: 'isCustomer', value: true });
                this.IsCustomer = true;
            }
            
            if (conditions.isInvoice) {
                this.lstQuery.push('有發票');
                this.queryConditionMap.set('有發票', { type: 'isInvoice', value: true });
                this.IsInvoice = true;
            }
            
            if (conditions.isImport) {
                this.lstQuery.push('有進口');
                this.queryConditionMap.set('有進口', { type: 'isImport', value: true });
                this.IsImport = true;
            }
            
            if (conditions.isExport) {
                this.lstQuery.push('有出口');
                this.queryConditionMap.set('有出口', { type: 'isExport', value: true });
                this.IsExport = true;
            }
            
            if (conditions.isFactory) {
                this.lstQuery.push('有工廠');
                this.queryConditionMap.set('有工廠', { type: 'isFactory', value: true });
                this.IsFactory = true;
            }
            
            // 資本額
            if (conditions.capital && conditions.capital.range) {
                this.lstQuery.push(conditions.capital.range);
                this.queryConditionMap.set(conditions.capital.range, { 
                    type: 'capital', 
                    value: conditions.capital 
                });
            }
            
            // 設立日期
            if (conditions.setupDate && conditions.setupDate.range) {
                this.lstQuery.push(conditions.setupDate.range);
                this.queryConditionMap.set(conditions.setupDate.range, { 
                    type: 'setupDate', 
                    value: conditions.setupDate 
                });
            }
            
            // 行業代碼（陣列）
            if (conditions.industryCode && Array.isArray(conditions.industryCode)) {
                conditions.industryCode.forEach(code => {
                    this.lstQuery.push(code);
                    this.queryConditionMap.set(code, { type: 'industryCode', value: code });
                });
            }
            
            // 地址
            if (conditions.location && (conditions.location.city || conditions.location.district)) {
                const locationText = `${conditions.location.city || ''}${conditions.location.district || ''}`;
                this.lstQuery.push(locationText);
                this.queryConditionMap.set(locationText, { type: 'location', value: conditions.location });
            }
            
            console.log('重建後的狀態:', {
                lstQuery: this.lstQuery,
                queryConditions: this.queryConditions,
                mapping: Array.from(this.queryConditionMap.entries())
            });
        }, 

        // 清空所有查詢條件
        clearAllQueryConditions() {
            // 清空顯示標籤
            this.lstQuery = [];
            
            // 清空結構化資料
            this.queryConditions = {
                keyword: '',
                companyStatus: '',
                companyType: [],
                orgType: [],
                isCustomer: false,
                isInvoice: false,
                isImport: false,
                isExport: false,
                isFactory: false,
                capital: { start: '', end: '', range: '' },
                setupDate: { range: '', start: '', end: '', rangeValue: '' },
                industryCode: [],
                location: { area: '', city: '', district: '' }
            };
            
            // 清空映射表
            this.queryConditionMap.clear();
            
            // 清空 UI 狀態
            this.keyword = '';
            this.selectedComStatus = '全部';
            this.selectedComType = '全部';
            this.selectedOrgType = '全部';
            this.IsCustomer = false;
            this.IsInvoice = false;
            this.IsImport = false;
            this.IsExport = false;
            this.IsFactory = false;
            this.TotCapStart = '';
            this.TotCapEnd = '';
            this.radCap = '';
            this.yearCap = '';
            this.selectedCity = '全部';
            this.selectedDistrict = '';
            this.selectedIndustryCode = [];
        },       
        
        // 更新組織別處理
        orgTypeChangeHandler(value) {
            console.log('組織別變更:', value);
            
            if (value === '全部') {
                // 移除所有組織別標籤
                this.OrgTypeList.forEach(item => {
                    if (this.lstQuery.includes(item.comType)) {
                        this.removeQueryCondition(item.comType);
                    }
                });
            } else {
                // 先移除 "全部" 標籤
                if (this.lstQuery.includes('全部')) {
                    this.removeQueryCondition('全部');
                }
                
                // 添加新的組織別
                this.addQueryCondition('orgType', value, value);
            }
            
            this.selectedOrgType = value;
        },
        
        // 更新其他條件處理
        otherChangeHandler(value) {
            const conditionMap = {
                '既有客戶': { type: 'isCustomer', checked: this.IsCustomer },
                '有發票': { type: 'isInvoice', checked: this.IsInvoice },
                '有進口': { type: 'isImport', checked: this.IsImport },
                '有出口': { type: 'isExport', checked: this.IsExport },
                '有工廠': { type: 'isFactory', checked: this.IsFactory }
            };
            
            const condition = conditionMap[value];
            if (condition) {
                if (condition.checked) {
                    this.addQueryCondition(condition.type, true, value);
                } else {
                    this.removeQueryCondition(value);
                }
            }
        },          

        // 更新公司狀況處理
        comStatusChangeHandler(value) {
            console.log('公司狀況變更:', value);
            
            // 先移除舊的公司狀況標籤
            const statusTags = ['全部', '營業中', '非營業中'];
            statusTags.forEach(tag => {
                if (this.lstQuery.includes(tag)) {
                    this.removeQueryCondition(tag);
                }
            });
            
            // 添加新的條件
            if (value && value !== '全部') {
                this.addQueryCondition('companyStatus', value, value);
            }
            
            this.selectedComStatus = value;
        },


        // 更新公司類別處理
        comTypeChangeHandler(value) {
            console.log('公司類別變更:', value);
            
            if (value === '全部') {
                // 移除所有公司類別標籤
                this.ComTypeList.forEach(item => {
                    if (this.lstQuery.includes(item.comType)) {
                        this.removeQueryCondition(item.comType);
                    }
                });
            } else {
                // 先移除 "全部" 標籤
                if (this.lstQuery.includes('全部')) {
                    this.removeQueryCondition('全部');
                }
                
                // 添加新的公司類別
                this.addQueryCondition('companyType', value, value);
            }
            
            this.selectedComType = value;
        },

        // 更新資本額處理
        radClick(val) {
            console.log(val);
            
            // 如果選擇自訂區間，開啟對話框
            if (val === 'custom') {
                this.showCustomCapital = true;
                return;
            }
            
            const capInfo = this.capList.find(x => x.value === val);
            const displayText = capInfo.cap;
            
            // 先移除舊的資本額標籤
            this.capList.forEach(cap => {
                if (this.lstQuery.includes(cap.cap)) {
                    this.removeQueryCondition(cap.cap);
                }
            });
            
            // 移除之前的自訂區間標籤
            const customTags = this.lstQuery.filter(tag => tag.includes('萬~') && tag.includes('萬'));
            customTags.forEach(tag => {
                this.removeQueryCondition(tag);
            });
            
            // 添加新的資本額條件
            this.addQueryCondition('capital', {
                start: capInfo.start,
                end: capInfo.end,
                range: displayText
            }, displayText);
            
            this.radCap = val;
        },
        
        // 確認自訂資本額區間
        confirmCustomCapital() {
            const start = parseFloat(this.customCapital.start);
            const end = parseFloat(this.customCapital.end);
            
            // 驗證輸入
            if (!start || !end) {
                notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束金額' });
                return;
            }
            
            if (start >= end) {
                notify({ type: 'warning', title: '警告', message: '起始金額必須小於結束金額' });
                return;
            }
            
            // 移除舊的資本額標籤（包括預設選項和之前的自訂區間）
            this.capList.forEach(cap => {
                if (this.lstQuery.includes(cap.cap)) {
                    this.removeQueryCondition(cap.cap);
                }
            });
            
            // 移除之前的自訂區間標籤
            const customTags = this.lstQuery.filter(tag => tag.includes('萬~') && tag.includes('萬'));
            customTags.forEach(tag => {
                this.removeQueryCondition(tag);
            });
            
            // 建立顯示文字
            const displayText = `${start}萬~${end}萬`;
            
            // 添加新的資本額條件
            this.addQueryCondition('capital', {
                start: start,
                end: end,
                range: displayText
            }, displayText);
            
            // 清空輸入並關閉對話框
            this.customCapital.start = '';
            this.customCapital.end = '';
            this.showCustomCapital = false;
            
            notify({ type: 'success', title: '成功', message: `已設定資本額區間：${displayText}` });
        },
        
        // 更新設立日期處理
        yearClick(val) {
            // 如果選擇自訂區間，開啟對話框
            if (val === 'custom') {
                this.showCustomYear = true;
                return;
            }
            
            const yearInfo = this.yearList.find(x => x.value === val);
            const displayText = yearInfo.cap;
            
            // 計算實際的日期範圍
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - yearInfo.end;
            const endYear = currentYear - yearInfo.start;
            
            const startDate = `${startYear}-01-01`;
            const endDate = `${endYear}-12-31`;
            
            console.log('設立日期計算:', {
                currentYear,
                yearInfo,
                startYear,
                endYear,
                startDate,
                endDate
            });
            
            // 先移除舊的設立日期標籤
            this.yearList.forEach(year => {
                if (this.lstQuery.includes(year.cap)) {
                    this.removeQueryCondition(year.cap);
                }
            });
            
            // 移除之前的自訂區間標籤
            const customTags = this.lstQuery.filter(tag => tag.includes('年~') && tag.includes('年'));
            customTags.forEach(tag => {
                this.removeQueryCondition(tag);
            });
            
            // 添加新的設立日期條件
            this.addQueryCondition('setupDate', {
                range: displayText,
                start: startDate,
                end: endDate,
                rangeValue: val
            }, displayText);
            
            this.yearCap = val;
        },
        
        // 確認自訂設立日期區間
        confirmCustomYear() {
            const start = parseFloat(this.customYear.start);
            const end = parseFloat(this.customYear.end);
            
            // 驗證輸入
            if (!start || !end) {
                notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束年限' });
                return;
            }
            
            if (start >= end) {
                notify({ type: 'warning', title: '警告', message: '起始年限必須小於結束年限' });
                return;
            }
            
            // 移除舊的設立日期標籤（包括預設選項和之前的自訂區間）
            this.yearList.forEach(year => {
                if (this.lstQuery.includes(year.cap)) {
                    this.removeQueryCondition(year.cap);
                }
            });
            
            // 移除之前的自訂區間標籤
            const customTags = this.lstQuery.filter(tag => tag.includes('年~') && tag.includes('年'));
            customTags.forEach(tag => {
                this.removeQueryCondition(tag);
            });
            
            // 建立顯示文字
            const displayText = `${start}年~${end}年`;
            
            // 計算實際的日期範圍
            const currentYear = new Date().getFullYear();
            const startDate = `${currentYear - end}-01-01`;
            const endDate = `${currentYear - start}-12-31`;
            
            // 添加新的設立日期條件
            this.addQueryCondition('setupDate', {
                range: displayText,
                start: startDate,
                end: endDate,
                rangeValue: 'custom'
            }, displayText);
            
            // 清空輸入並關閉對話框
            this.customYear.start = '';
            this.customYear.end = '';
            this.showCustomYear = false;
            
            notify({ type: 'success', title: '成功', message: `已設定設立日期區間：${displayText}` });
        },   

        // 更新行業代碼處理
        handleIndustryCodeChange(value, selectedItems) {
            if (!value || value.length === 0) {
                return;
            }
            
            // 確保 selectedItems 存在且為陣列
            if (!selectedItems || !Array.isArray(selectedItems) || selectedItems.length === 0) {
                console.warn('selectedItems 為空或無效');
                return;
            }
            
            selectedItems.forEach(item => {
                if (item && item.label) {
                    this.addQueryCondition('industryCode', value[3], item.label);
                }
            });
            
            this.selectedIndustryCode = [];
        },        

        settingBranchPreference(row) {
            this.selectedRow = row;
            this.lstQuery = [];
            this.clearAllQueryConditions();

            console.log("settingBranchPreference Parameters", row.Parameters);

            // 載入現有偏好設定
            try {
                if (row.Parameters) {
                    this.queryConditions = JSON.parse(row.Parameters);
                } else {
                    // 如果沒有Parameters, 使用預設值
                    this.queryConditions = {
                        keyword: '',
                        companyStatus: '',
                        companyType: [],
                        orgType: [],
                        isCustomer: false,
                        isInvoice: false,
                        isImport: false,
                        isExport: false,
                        isFactory: false,
                        capital: { start: '', end: '', range: '' },
                        setupDate: { range: '', start: '', end: '', rangeValue: '' },
                        industryCode: [],
                        location: { area: '', city: '', district: '' },
                        geolocation: { Latitude: '', Longitude: '', Distance: '' }
                    };
                }
            } catch (err) {
                console.warn('設定Parameters JSON.parse 出場錯誤:', err);
                // JSON parse 失敗, 使用預設值
                this.queryConditions = {
                    keyword: '',
                    companyStatus: '',
                    companyType: [],
                    orgType: [],
                    isCustomer: false,
                    isInvoice: false,
                    isImport: false,
                    isExport: false,
                    isFactory: false,
                    capital: { start: '', end: '', range: '' },
                    setupDate: { range: '', start: '', end: '', rangeValue: '' },
                    industryCode: [],
                    location: { area: '', city: '', district: '' },
                    geolocation: { Latitude: '', Longitude: '', Distance: '' }
                };
            }
            console.log("settingBranchPreference selectedRow", this.queryConditions);            
            console.log("before lstQuery", this.lstQuery);      
            // 從 queryConditions 重建 lstQuery 和映射關係
            this.rebuildFromQueryConditions(this.queryConditions);      
            console.log("settingBranchPreference lstQuery", this.lstQuery);      

            this.showBranchPreference = true;            
        },        

        handleDivChange(val) {
            console.log("handleDivChange", val);
            // console.log("handleDivChange selectedDiv", this.selectedDiv);
            this.listQuery.DivisionCode = val.DivisionCode;
            this.listQuery.DeptID = val.DeptID;
        },

        editBranch(row) {
            this.addInfo = Object.assign({}, row);
            console.log("editBranch", this.addInfo);
            this.showAddBranch = true;
            if( this.btnOptions.editBtn ) {
                this.dialogTitle = "編輯分行帳號";
            }
            else {
                this.dialogTitle = "檢視分行帳號";
            }

            this.dialogButton = "儲存";
            // 清空表單驗證
            this.$nextTick(() => {
                if (this.$refs.addInfoForm) {
                    this.$refs.addInfoForm.clearValidate();
                }
            });
        },

        addBranch() {
            this.showAddBranch = true;
            this.dialogTitle = "新增分行帳號";
            this.dialogButton = "新增";            
            this.addInfo = {
                "BranchCode": "",
                "BranchFullName": "",
                "DeptID": "",
                "DeptName": "",
                "DivisionName": "",
                "Manager": "",
                "Phone": "",
                "Address": "",
                "Latitude": "",
                "Longitude": ""
            };
            // 清空表單驗證
            this.$nextTick(() => {
                if (this.$refs.addInfoForm) {
                    this.$refs.addInfoForm.clearValidate();
                }
            });
        },

        dashFormat: function(value) {
            
            if( value===null || value?.length!=8) 
                return "";
            else  {                
                return value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6);
            }
        },

        async doSearch() {
            console.log("doSearch", this.listQuery);
            this.listQuery.Page_Num = 1;
            this.listQuery.Page_Size = 10;     
            if( this.keyword ) {
                this.listQuery.DeptName = this.keyword;
            }       
            await this.getList();
        },

        async getList() {
            this.$store.dispatch("loadingHandler", true);
            let qry = {
                "Page_Size": this.listQuery.Page_Size,
                "Page_Num": this.listQuery.Page_Num
            }

            console.log("selectedDiv", this.selectedDiv);
            if( this.selectedDiv && this.selectedDiv.length>0 ) {                
                qry.DeptID = this.selectedDiv[1];
            }            

            // 若是UC, 只能看到自己的分行資料
            if( this.roleName=="UC" || this.roleName=="UAO" ) {
                qry.DeptID = this.deptID;
            }

            // 若是 HE, HC1 , 只能看到自己的區處 
            if( this.roleName=="HE" || this.roleName=="HC1" ) {
                qry.DivisionCode = this.DivisionCode;
            }
            // 若是 HC, HD, 則不限制.

            // 關鍵字
            if( this.keyword ) {
                qry.DeptName = this.keyword;
            }

            console.log("getList qry", qry);
            this.$api.apidivison.division_info_list(qry).then( res => {
                this.tableData = Array.isArray(res.data)
                    ? res.data.map(item => ({
                        ...item,
                        ID: item.ID
                    }))
                    : [];
                this.totalLists = res.total;
                console.log(res);
            }).catch( err => {
                console.log(err);
            });
            this.$store.dispatch("loadingHandler", false);
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },  
        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },
                // 更新標籤關閉處理
        handleClose(tag) {
            this.removeQueryCondition(tag);
        },     
        
        delBranch(row) {
            console.log("delBranch", row);
            this.$confirm('確定要刪除分行 "' + row.BranchFullName + '" 嗎?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (!row || !row.ID) {
                    notify({
                        type: 'error',
                        title: '錯誤',
                        message: '缺少 ID，無法刪除分行'
                    });
                    return;
                }
                // 這裡實現刪除分行的邏輯
                // 例如發送API請求或從本地數據中移除
                const qry= {
                    "ID": row.ID
                };
                this.$api.apidivison.division_info_delete(qry).then( res => {
                    notify({
                        type: 'success',
                        title: '成功',
                        message: '分行 "' + row.BranchFullName + '" 刪除成功！'
                    });
                    this.refreshDivSelection();
                    this.getList();
                }).catch( err => {
                    console.log(err);
                });

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消刪除'
                });          
            });
        },  
                                     

    },    

    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        await this.getFunctions();
        await this.getList();
        
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
//  * {
//      outline: 1px solid red;
//  }


#hqSettingBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;


  .dialogBox {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;

    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        
        .itemBox {
            flex: 1;
            margin: 0px 10px;
            
            // el-form-item 的樣式
            ::v-deep .el-form-item__label {
                font-weight: bold;
                font-size: medium;
            }

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
                
            }
            button {
                text-align: right;
            }
        }
        .itemBox2 {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            align-items: center;
            margin: 10px 10px;            
            width: 100%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }        
    }       
    
    .row2 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;    
        align-items: center;
           
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            
            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }            
    }
    

  }


  .searchWrap   {
    display: flex;
    flex-direction: row;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: center;
        width:100%;

        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin-top:20px; 
            margin-bottom: 20px;
            
        }
        

    }
    .row3 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top:20px; 
        margin-bottom: 20px;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }     
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }

   .titleLabel {
        font-size: medium;
        font-weight: bold;
        margin-left: 10px;
        padding-right: 25px;        
   }   

  /* 自定義 el-dropdown 的尺寸為 medium */
  .el-dropdown-link {
    font-size: 16px;
    padding: 10px 15px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .el-dropdown-link i {
    font-size: 16px;
  }

  /* 調整下拉選項的尺寸 */
  ::v-deep .el-dropdown-menu__item {
    font-size: 16px;
    line-height: 36px;
    padding: 0 20px;
  }
}
</style>